module.exports = __webpack_public_path__ + "static/media/build.d2605492.svg";